/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo } from "react";
import { Control, useController } from "react-hook-form";
import { CustomDatepicker } from "tvs-unified-lib";

export interface DatePickerFieldProps {
  label?: string;
  name: string;
  control: Control<any>;
  isRequired?: boolean;
  placeholder?: string;
  minDate?: Date;
  disabled?: boolean;
  showMonthYearPicker?: boolean;
  format?: string;
}

export const DatePickerField = memo(
  ({
    label,
    name,
    control,
    isRequired = false,
    placeholder,
    minDate,
    disabled = false,
    showMonthYearPicker = false,
    format = "dd MMMM yyyy",
  }: DatePickerFieldProps) => {
    const {
      field: { onChange, value },
      fieldState: { error },
    } = useController({ name, control });

    return (
      <CustomDatepicker
        onResetDate={() => {
          if (!disabled) {
            onChange?.("");
          }
        }}
        placeholder={placeholder}
        showMonthYearPicker={showMonthYearPicker}
        format={format}
        value={value ?? ""}
        formLabel={label}
        isRequired={isRequired}
        onInputChange={(e) => {
          if (!disabled) {
            onChange?.(e);
          }
        }}
        hasError={!!error}
        errorMessage={isRequired && error?.message}
        minDate={minDate}
        disabled={disabled}
      />
    );
  }
);

export default DatePickerField;
